import { useState, useEffect, useRef } from "react";
import Header from "@/components/Header";
import IntroSection from "@/components/IntroSection";
import MessageSection from "@/components/MessageSection";
import MemoryGallery from "@/components/MemoryGallery";
import BirthdayReveal from "@/components/BirthdayReveal";
import FinalMessage from "@/components/FinalMessage";
import AudioSettingsModal from "@/components/MusicPermission";

const Index = () => {
  const [isDark, setIsDark] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showIntro, setShowIntro] = useState(true);
  const [showMessages, setShowMessages] = useState(false);
  const [showGallery, setShowGallery] = useState(false);
  const [showReveal, setShowReveal] = useState(false);
  const [showFinal, setShowFinal] = useState(false);
  const [showAudioPermission, setShowAudioPermission] = useState(true);
  const [hasInteracted, setHasInteracted] = useState(false);

  const audioRef = useRef(null);

  const girlfriendName = "Lariska";

  useEffect(() => {
    if (isDark) document.documentElement.classList.add("dark");
    else document.documentElement.classList.remove("dark");
  }, [isDark]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.src = "/Ghostly_Kisses_Heartbeat.mp3";
      audioRef.current.load();
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = "";
      }
    };
  }, []);

  const toggleTheme = () => setIsDark(!isDark);

  const toggleMusic = async () => {
    if (!audioRef.current) return;

    if (!hasInteracted) {
      setHasInteracted(true);
      setShowAudioPermission(false);
    }

    try {
      if (isPlaying) {
        await audioRef.current.pause();
        setIsPlaying(false);
      } else {
        const playPromise = audioRef.current.play();
        if (playPromise !== undefined) {
          await playPromise;
          setIsPlaying(true);
        }
      }
    } catch (error) {
      console.error("Error toggling music:", error);
      setIsPlaying(false);
    }
  };

  const handlePermissionDecision = (startMusic) => {
    setShowAudioPermission(false);
    if (startMusic) toggleMusic();
  };

  const handleIntroComplete = () => {
    setShowIntro(false);
    setTimeout(() => setShowMessages(true), 500);
  };

  const handleMessagesComplete = () => {
    setShowMessages(false);
    setTimeout(() => setShowGallery(true), 500);
  };

  const handleGalleryComplete = () => {
    setShowGallery(false);
    setTimeout(() => setShowReveal(true), 500);
  };

  const handleRevealComplete = () => {
    setShowReveal(false);
    setTimeout(() => setShowFinal(true), 500);
  };

  return (
    <div className="min-h-screen bg-background text-foreground transition-colors duration-500">
      <audio ref={audioRef} loop />

      <AudioSettingsModal
        isOpen={showAudioPermission}
        onDecision={handlePermissionDecision}
      />

      {!showAudioPermission && (
        <Header
          isDark={isDark}
          toggleTheme={toggleTheme}
          isPlaying={isPlaying}
          toggleMusic={toggleMusic}
        />
      )}

      {!showAudioPermission && (
        <main>
          {showIntro && <IntroSection name={girlfriendName} onComplete={handleIntroComplete} />}
          {showMessages && <MessageSection onComplete={handleMessagesComplete} />}
          {showGallery && <MemoryGallery onComplete={handleGalleryComplete} />}
          {showReveal && <BirthdayReveal onComplete={handleRevealComplete} />}
          {showFinal && <FinalMessage />}
        </main>
      )}
    </div>
  );
};

export default Index;